import { render, staticRenderFns } from "./ArticleManage.vue?vue&type=template&id=ed763768&scoped=true&"
import script from "./ArticleManage.vue?vue&type=script&lang=js&"
export * from "./ArticleManage.vue?vue&type=script&lang=js&"
import style0 from "./ArticleManage.vue?vue&type=style&index=0&id=ed763768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed763768",
  null
  
)

export default component.exports